import {ReportGlobalParametersModel} from './ReportGlobalParameters.model';
import {ReportStartUpInstructionsModel} from './ReportStartUpInstructions.model';

export class ReportStartUpObjectModel {
  reportGlobalParameters: ReportGlobalParametersModel;
  reportStartUpInstructions: ReportStartUpInstructionsModel;
}
